import { IconButton } from '@chakra-ui/react';
import ContentOverlay from '~/components/ContentOverlay';
import { CloseNarrowIcon } from '~/components/icons';
import { ContentNameType, ContentType } from '~/types/content';

interface Props {
  content: ContentType;
  contentType: ContentNameType;
  onChange: (id: string) => void;
  previewCard: React.ReactElement;
}

export const SelectedContentPreviewItem: React.FC<Props> = ({
  content,
  onChange,
  previewCard,
  ...rest
}) => (
  <ContentOverlay
    borderRadius="lg"
    isAlwaysVisible
    overlayProps={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      padding: '0',
    }}
    position="cover"
    transition="height 250ms, width 250ms"
    width={{ base: '48px', sm: '80px' }}
    {...rest}
  >
    <ContentOverlay.Trigger>{previewCard}</ContentOverlay.Trigger>

    <ContentOverlay.Content>
      <IconButton
        _active={{
          backgroundColor: 'white',
        }}
        _hover={{
          backgroundColor: 'white',
        }}
        aria-label="Remove"
        backgroundColor="white"
        height={{ base: 6, md: 8 }}
        icon={<CloseNarrowIcon boxSize="20px" />}
        minWidth={{ base: 6, md: 8 }}
        onClick={() => onChange(content.id)}
        rounded="full"
        sx={{
          '&:hover > svg': {
            color: 'secondary.500',
          },
        }}
      />
    </ContentOverlay.Content>
  </ContentOverlay>
);
